import { createBrowserRouter } from 'react-router-dom';
import { PrivacyApp } from '../about/PrivacyApp';
import { AppContainer } from './AppContainer';
import { EmailConfirmationPage } from '../auth/ConfirmationMessage/EmailConfirmedPage';
import { PasswordHasBeenSetPage } from '../auth/ConfirmationMessage/PasswordHasBeenSetPage';
import { Links } from 'shared/infrastructure/Links';
import { NotSupportedBrowser } from '../common/NotSupportedBrowser/NotSupportedPage';
import { EmailChangedConfirmationPage } from 'auth/ConfirmationMessage/EmailChangedConfirmationPage';
import { SpaIsClosed } from 'spa-is-closing/SpaIsClosed';
import { SetPasswordPage } from 'auth/ForgotPassword/SetPasswordPage';
import { About } from 'about/About';
import { Privacy } from 'about/Privacy';
import { Imprint } from 'about/Imprint';

export const router = createBrowserRouter([
  {
    path: Links.Welcome,
    element: <AppContainer />,
    children: [
      {
        path: Links.Welcome,
        element: <SpaIsClosed />,
      },
      {
        path: `${Links.PasswordHasBeenSet}`,
        element: <PasswordHasBeenSetPage />,
      },
      {
        path: `${Links.EmailConfirmed}/:userId/:code`,
        element: <EmailConfirmationPage />,
      },
      {
        path: `${Links.ConfirmChangeEmail}/:userId/:email/:code`,
        element: <EmailChangedConfirmationPage />,
      },
      {
        path: `${Links.ForgotPassword}/:email/:code`,
        element: <SetPasswordPage />,
      },
      {
        path: Links.BrowserNotSupported,
        element: <NotSupportedBrowser />,
      },
      {
        path: Links.About,
        element: <About />,
      },
      {
        path: Links.PrivacyApp,
        element: <PrivacyApp />,
      },
      {
        path: Links.Privacy,
        element: <Privacy />,
      },
      {
        path: Links.Imprint,
        element: <Imprint />,
      },
    ],
  },
]);
